import { BlockedRecordBlockedType } from '@exam-center/graphql';

import { STAFF_BLOCKED_TYPES } from '../../constants';

export function groupBlockedRecordsByBlockedType<
  T extends {
    blockedType: BlockedRecordBlockedType;
  },
>(blockedRecords: T[]) {
  return blockedRecords.reduce(
    (acc, record) => {
      if (
        STAFF_BLOCKED_TYPES.includes(
          record.blockedType as unknown as (typeof STAFF_BLOCKED_TYPES)[number],
        )
      ) {
        acc.staffRecords.push(record);
      }

      if (record.blockedType === BlockedRecordBlockedType.ExamPasser) {
        acc.examPasserRecords.push(record);
      }

      if (record.blockedType === BlockedRecordBlockedType.Cheater) {
        acc.cheaterRecords.push(record);
      }

      return acc;
    },
    {
      staffRecords: [] as T[],
      examPasserRecords: [] as T[],
      cheaterRecords: [] as T[],
    },
  );
}

const BLOCKED_PROCTOR_TYPES = [
  BlockedRecordBlockedType.Proctor_1,
  BlockedRecordBlockedType.Proctor_2,
  BlockedRecordBlockedType.Proctor_3,
];

export function checkIsProctorType(blockedType: BlockedRecordBlockedType) {
  return BLOCKED_PROCTOR_TYPES.includes(blockedType);
}
